<script setup lang="ts">
/**
 * UI-kit component
 * Category: Tables
 * Name: 'AppTd'
 */
import type { AppTdProps } from '../types/interfaces'

defineOptions({
  name: 'AppTd',
})

withDefaults(defineProps<AppTdProps>(), {
  colspan: 0,
})
</script>

<template>
  <td
    class="app-td"
    :colspan="colspan || undefined"
  >
    <slot />
  </td>
</template>

<style lang="scss" scoped src="../styles/_app-table.scss" />
